'use strict';


function pdpActiveBenefitsBadges() {
    $("#benefits-badges").removeClass('d-none');
    $("#subscription-benefits-badges").addClass('d-none');
}

function pdpActiveSubscriptionBadges() {
    $("#subscription-benefits-badges").removeClass('d-none');
    $("#benefits-badges").addClass('d-none');
}

function pdpActiveSunOpticalBenefitsBadges() {
    if ($("#switch-to-cristales").prop("checked")) {
        $("#sun-optical-benefits-badges").removeClass('d-none');
        $("#benefits-badges").addClass('d-none');
    } else {
        $("#benefits-badges").removeClass('d-none');
        $("#sun-optical-benefits-badges").addClass('d-none');
    }
}

/**
 *
 */
function init() {
    $(document).on('subscription:tabSelected', function () {
        pdpActiveSubscriptionBadges();
    });

    $(document).on('buyOnePdp:tabSelected', function () {
        pdpActiveBenefitsBadges();
    });

    $(document).on('pdp:changeSwitchToCristales', function () {
        pdpActiveSunOpticalBenefitsBadges();
    });

    //Remove html content
    $('.benefit-badge').each(function(index, element) {
        let content = $(element).text();
        var plainText = content.replace(/<[^>]*>?/gm, '');
        $(element).text(plainText);
    });
};

module.exports = {
    init: init
};
